import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, postApi } from 'services/_api';
import { CHANNEL, PATH_PROCON } from 'services/_path';

// TYPES
import { Types } from './types';

// ACTIONS
import { consultaAreasSuccess, consultaAreasFailure } from './actions';

function* consultaAreasRequest() {
	const response: ApiResponse = yield call(
		postApi,
		PATH_PROCON,
		`areas/${CHANNEL}/areas`,
		{},
	);

	if (response.status === 200) {
		yield put(consultaAreasSuccess(response));
	} else {
		yield put(consultaAreasFailure(response));
	}
}

export default all([
	takeLatest(Types.CONSULTA_AREAS_REQUEST, consultaAreasRequest),
]);
